import {ModalPopup} from "components/shared/ModalPopup/ModalPopup";
import {Button} from "components/shared/Button/Button";
import { useTooltip } from "./useTooltip";
import "./Tooltip.scss";

export const Tooltip = () => {
  const { title, subTitle, show, onNext } = useTooltip(0);
  if (!show) return null;

  return (
    <ModalPopup
      id="Tooltip"
      size="xs"
      show={show}
      className="Tooltip"
      onClose={onNext}
    >
      <div className="Tooltip-content content">
        {title && <h3 className="Tooltip-title title">{title}</h3>}
        {subTitle && <p className="Tooltip-subtitle">{subTitle}</p>}

        <div className="Tooltip-footer footer">
          <Button onClick={onNext} size="md" color="dark">
            Got It
          </Button>
        </div>
      </div>
    </ModalPopup>
  );
};
